import { render, staticRenderFns } from "./GroupPiecesAdmin.vue?vue&type=template&id=4291f260&scoped=true"
import script from "./GroupPiecesAdmin.vue?vue&type=script&lang=js"
export * from "./GroupPiecesAdmin.vue?vue&type=script&lang=js"
import style0 from "./GroupPiecesAdmin.vue?vue&type=style&index=0&id=4291f260&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4291f260",
  null
  
)

export default component.exports